import { evictAccountUsersCache } from './accountUsers/evictAccountUsersCache';

/**
 * All cache-cleanup tasks, run once on app startup. Each task purges its own cache (by retention,
 * size, etc.). This is the single place that knows the cleaners — add a cache's cleaner here when it
 * needs eviction; callers just invoke `runCacheMaintenance`.
 *
 * @type {Array<() => Promise<void>>}
 */
const cacheCleaners = [evictAccountUsersCache];

/**
 * Runs every cache-cleanup task once. Failures are isolated via `Promise.allSettled`, so one failing
 * cleaner does not prevent the others from running.
 *
 * @returns {Promise<void>} Resolves after all cleaners have settled.
 */
export const runCacheMaintenance = async () => {
    await Promise.allSettled(cacheCleaners.map((cleaner) => cleaner()));
};
